import React, { PropTypes } from 'react';
import './sideBar.css';


const propTypes = {
  locale: PropTypes.string.isRequired,
};

const SideBar = () => {
  return (
    <aside className="bottom aligned row" />
  );
};

SideBar.propTypes = propTypes;

export default SideBar;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sideBar/SideBar.js
 **/